// extracted by mini-css-extract-plugin
export default {"screenRoot":"CapsulesSettingsLayout_screenRoot__3XHjz"};